module.exports = __webpack_public_path__ + "static/img/fluent-text-font-20-regular.90424cca.svg";